;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	const Controller = APP.module('Controller');
	const View = APP.module('View');
	const Model = APP.module('Model');

	_.extend(Controller.Root.prototype, {
		start: function () {
			this.showHeader()
				.initializePopup()
				.showNotificationBanner()
			;
		},
		showNotificationBanner: function () {
			const notificationBanner = new View.NotificationBanner({
				model: new Model.NotificationBanner()
			});
			APP.notification_bar.show(notificationBanner);
		},
	});

}(window, APP, Backbone, Marionette, $, _));
